import React from 'react';
import {
  IonButton,
  IonText,
  IonLabel,
  IonRow,
  IonCol
} from '@ionic/react';
import { Card, Text } from '@tremor/react';
import { colorTheme } from '../../../utils/constants';
import FormattedPhoneInput from '../../../components/HandlePhoneNumbers/PhoneInputWithValidation';
import { extractNumber, formatAmount } from '../../../utils/numberFormat';

const MpesaPayment = ({
  amount,
  phoneNumber,
  phoneNumberFormatted,
  onPhoneNumberChange,
  onPhoneNumberValidation,
  onStkPush,
  errors
}) => {
  const cleanAmount = extractNumber(amount);

  return (
    <Card
      style={{
        borderRadius: '10px',
        padding: '1rem',
      }}
    >
      <IonText>
        <h3>Payment Instructions</h3>
      </IonText>

      <div className="ion-margin-top">
        <IonLabel>Amount</IonLabel>
        <div className="ion-text-bold ion-margin-bottom">KES {formatAmount(cleanAmount)}</div>

        <IonLabel htmlFor="phoneNumber">Phone Number</IonLabel>
        <FormattedPhoneInput
          country="ke"
          id="phoneNumber"
          name="phoneNumber"
          phoneNumber={phoneNumber}
          onPhoneNumberChange={onPhoneNumberChange}
          onPhoneNumberValidation={onPhoneNumberValidation}
          className="ion-margin-bottom"
        />

        {errors.phoneNumber && (
          <IonText color="danger">
            <small>{errors.phoneNumber}</small>
          </IonText>
        )}

        <IonRow className="ion-justify-content-center">
          <IonCol size="10" className="ion-text-center">
            <IonButton
              expand="block"
              className="ion-margin-top"
              color="primary"
              disabled={!!errors.phoneNumber}
              onClick={() => onStkPush(phoneNumberFormatted || phoneNumber)}
            >
              Get MPESA Prompt
            </IonButton>
          </IonCol>
        </IonRow>
      </div>

      <IonText className="ion-text-center">
        <p className="ion-margin-top">
          Once you complete paying, click the Done button below.
        </p>
      </IonText>
    </Card>
  );
};

export default MpesaPayment;
